import React from "react";
import Navbar from "./navbar";
import { useLocation } from "react-router-dom";

const Layout = ({ children }) => {
    const location = useLocation();
    
      const isFunPage = location.pathname === '/funprojects';
      const isServerPage = location.pathname === '/serverApi'

    return (
        <>
            {!isFunPage && !isServerPage && <Navbar />}
            <main>{children}</main>
        </>
    );
};

export default Layout;
